import http from '../utils/request'

// ========== 流程权限 ==========

/** 获取流程权限列表 */
export const getProcessPermissions = (processId) => http.get(`/permission/process/${encodeURIComponent(processId)}`)

/** 保存流程权限 */
export const saveProcessPermission = (data) => http.post('/permission/process', data)

/** 删除流程权限 */
export const deleteProcessPermission = (guid) => http.delete(`/permission/process/${encodeURIComponent(guid)}`)

// ========== 模块权限 ==========

/** 获取模块权限列表 */
export const getModulePermissions = (moduleId) => http.get(`/permission/module/${encodeURIComponent(moduleId)}`)

/** 保存模块权限 */
export const saveModulePermission = (data) => http.post('/permission/module', data)

/** 删除模块权限 */
export const deleteModulePermission = (guid) => http.delete(`/permission/module/${encodeURIComponent(guid)}`)

// ========== 报表权限 ==========

/** 获取报表权限列表 */
export const getReportPermissions = (reportId) => http.get(`/permission/report/${encodeURIComponent(reportId)}`)

/** 保存报表权限 */
export const saveReportPermission = (data) => http.post('/permission/report', data)

/** 删除报表权限 */
export const deleteReportPermission = (guid) => http.delete(`/permission/report/${encodeURIComponent(guid)}`)

// ========== 公告权限 ==========

/** 获取公告权限列表 */
export const getAnnouncementPermissions = (announcementId) => http.get(`/permission/announcement/${encodeURIComponent(announcementId)}`)

/** 保存公告权限 */
export const saveAnnouncementPermission = (data) => http.post('/permission/announcement', data)

/** 删除公告权限 */
export const deleteAnnouncementPermission = (guid) => http.delete(`/permission/announcement/${encodeURIComponent(guid)}`)
